import { useEffect } from "react";
import { captureAttribution } from "@/lib/marketing/attribution";
import { initMarketingAnalytics } from "@/lib/marketing/analytics";

/**
 * Runs once per public page mount (via `PublicHeader`): stores first-touch
 * attribution and starts marketing analytics. Both are idempotent.
 */
export function useMarketingSite(): void {
  useEffect(() => {
    captureAttribution();
    void initMarketingAnalytics();
  }, []);
}
